module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-screen1@2x-008b0ebe5a48231f5721869743bfe22c.png";